<template>
  <div class="wrap">
    <div class="header">
      <div class="header-price"><span>¥</span>{{ showAmount }}</div>
    </div>
    <div class="content">
      <HbBenefit
        v-for="item in categoryList"
        :key="item.id"
        :item="item"
        :allBenefitList="benefitList"
      />
      <div class="footer">
        权益由橡树提供，服务热线：<span>400-150-9669</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  ref,
  computed,
} from "@vue/composition-api";
import Vue from "vue";
import Decimal from "decimal.js";

import { useStore, useRoute } from "@/components/use/base";
import useMoreCard from "@/use/useMoreCard";
import { getNamespaceBenefit } from "@/apis/home";
import { jsonSafeParse } from "@/utils";

import HbBenefit from "../component/common/HbBenefit.vue";

const vm = Vue.prototype;

export default defineComponent({
  components: {
    HbBenefit,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const { initMoreCardForVisitor, categoryList } = useMoreCard();
    const benefitList = ref([]);
    const totalValue = route.query.total_value || 0;

    const packageName = computed(() => store.state.namespaceInfo.package);
    const namespace = computed(() => store.state.namespace);
    const showAmount = computed(() => {
      const value = totalValue;
      if (value === null || value === undefined || value === "") {
        return "";
      }
      const decimal = new Decimal(value);
      const str = decimal.isInteger() ? decimal.toFixed(0) : decimal.toFixed(2);
      const [integer, fraction] = str.split(".");
      const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return fraction ? `${formattedInteger}.${fraction}` : formattedInteger;
    });

    const initPageInfo = async () => {
      const packageMap = jsonSafeParse(vm.$getConfigValue("WC_CARD_MAP"));
      const page = packageMap[namespace.value];
      initMoreCardForVisitor(page);
      const { data: benefitData } = await getNamespaceBenefit({
        package: packageName.value.split(",")[0],
        namespace: namespace.value,
      });
      benefitList.value = benefitData.map((item) => item.benefit_type);
    };

    onMounted(async () => {
      initPageInfo();
    });

    return {
      categoryList,
      benefitList,
      totalValue,
      showAmount,
    };
  },
});
</script>

<style scoped lang="less">
.wrap {
  background: #eeeff3;
}

.header {
  width: 100%;
  height: 364px;
  background: url("https://common-h5-dev.xiangshuheika.com/static/upload/20260525b868c9c37d7f7.png")
    no-repeat center/100%;
  position: relative;

  .header-price {
    position: absolute;
    top: 134px;
    left: 50%;
    transform: translateX(-50%);
    font-family: "dinpro";
    font-size: 50px;
    color: #ff561a;
    line-height: 54px;
    text-align: center;
    display: flex;
    font-style: normal;
    align-items: flex-end;
    span {
      display: block;
      font-family: PingFangSC-Light, PingFang SC;
      margin-block: 7px;
      font-weight: 700;
      font-size: 24px;
      line-height: 24px;
    }
  }
}

.content {
  background: #ffffff;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
}

.footer {
  margin: 40px auto;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #333333;
  line-height: 17px;
  text-align: center;
  font-style: normal;
  > span {
    color: #fc4b21;
  }
}
</style>